import React, { Component } from 'react';
import { Tabs, Tab } from 'material-ui/Tabs';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';

import Assignment from 'material-ui/svg-icons/action/assignment';
import List from 'material-ui/svg-icons/action/list';

import Report from './Report';

import './PronounceMenu.css';
import languageNames from '../modules/languagenames';
import perm from '../modules/auth';

import { downloadReport } from '../actions/actions';

class PronounceMenu extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      saveOpen: false,
      reportOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.history.hasFetched === false && this.props.history.hasFetched === true) {
      const anchorEl = document.createElement('a');
      anchorEl.setAttribute('target', '_blank');
      anchorEl.setAttribute('href', this.props.history.reportURL);
      anchorEl.click();
    }
  }

  handleDialogOpen = () => {
    this.setState({ open: true });
  };

  handleDialogClose = () => {
    this.setState({ open: false });
  };

  handleSaveDialogOpen = () => {
    this.setState({ saveOpen: true });
  };

  handleSaveDialogClose = () => {
    this.setState({ saveOpen: false });
  };

  handleReportDialogOpen = () => {
    this.setState({ reportOpen: true });
  };

  handleReportDialogClose = () => {
    this.setState({ reportOpen: false });
  };

  getGroupExercises = () => this.props.exercises.exercises.filter(exercise => exercise.group_id !== null);

  getMyExercises = () => this.props.exercises.exercises.filter(exercise => exercise.group_id === null);

  downloadReport = () => {
    const logTime = sessionStorage.getItem('pronounce-time-spent');
    const timeSpent = performance.now() - logTime;

    this.props.dispatch(downloadReport({ history: this.props.history.history, timeSpent }));
  }

  renderExercise(item, index) {
    return (
      <li key={`exercise-${index}`}>
        <button
          onClick={() => {
            this.handleDialogClose();
            this.props.launchExercise(item.originalIndex);
          }}
        >
          {item.name}
        </button>
      </li>
        );
  }

  renderMenuItem(item, index, type) {
    const language = languageNames[item] || item;
    const exercises = this.props.exercises.exercises;

    const canBeUsed = this.props.voices.filter(v => v.lang.toLowerCase() === item.toLowerCase()).length > 0; // eslint-disable-line max-len

    exercises.forEach((exercise, exerciseIndex) => {
      exercise.originalIndex = exerciseIndex; // eslint-disable-line no-param-reassign
    });

    let filteredExercises;
    if (type === 'group') {
      filteredExercises = exercises.filter(v => (v.group_id !== null && v.language.toLowerCase() === item.toLowerCase())); // eslint-disable-line max-len
    } else {
      filteredExercises = exercises.filter(v => (v.group_id === null && v.language.toLowerCase() === item.toLowerCase())); // eslint-disable-line max-len
    }
    if (!canBeUsed) {
      return (
        <h3 key={index}>You have exercises in {language},
        but your device does not support this language</h3>
      );
    }

    return (
      <ul className="exercise-list" key={index}>
        <li className="exercise-language-header">{language}
        </li>
        {filteredExercises.map((exercise, i) => this.renderExercise(exercise, i))}
      </ul>
        );
  }

  render() {
    const { auth } = this.props;

    perm.setPermissions(auth.user.permissions);
    perm.setRole(auth.user.role);

    const openLabel = (!this.props.config.isTablet && !this.props.config.isPhone)
            ? 'Exercises'
            : '';

    const downloadLabel = (!this.props.config.isTablet && !this.props.config.isPhone)
            ? 'Report'
            : '';

    const groupExercises = this.getGroupExercises();
    const myExercises = this.getMyExercises();

    const groupLanguages = Array.from([...new Set(groupExercises.map(item => item.language))]);
    const myLanguages = Array.from([...new Set(myExercises.map(item => item.language))]);

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onTouchTap={
                this.handleDialogClose
            }
      />];


    const reportActions = [
      <FlatButton
        label="Cancel"
        primary
        onTouchTap={this.handleReportDialogClose}
      />,
      <FlatButton
        id="dlReport"
        label="Download PDF"
        primary
        onTouchTap={this.downloadReport}
      />,
    ];

    const style = {
      marginRight: '12px',
    };

    const exerciseDialog = (
      <Dialog actions={actions} modal={false} open={this.state.open} onRequestClose={this.handleDialogClose} autoScrollBodyContent={true}>
        <Tabs>
          {auth.user.hasGroup && (
          <Tab label="Group Exercises" >
            <h3>Group Exercises</h3>
            {groupLanguages.map((item, index) => this.renderMenuItem(item, index, 'group'))}
          </Tab>
      )}
          <Tab label="My Exercises" >
            <h3>My Exercises</h3>
            {myLanguages.map((item, index) => this.renderMenuItem(item, index, 'my'))}
          </Tab>
        </Tabs>
      </Dialog>
        );

    const reportDialog = (
      <Dialog title="Report" actions={reportActions} modal={false} open={this.state.reportOpen} onRequestClose={this.handleReportDialogClose} autoScrollBodyContent>
        <Report history={this.props.history} />
      </Dialog>
          );

    return (
      <div className="pronounce-exercise-launcher">
        {/* <RaisedButton
          style={style}
          disabled={!this.props.isStopped()}
          onTouchTap={this.props.clearExercise}
          icon={<Clear />}
          label={clearLabel}
        />*/}
        {!this.props.standAlone && (
        <RaisedButton
          id="loadExercises"
          style={style}
          label={openLabel}
          disabled={!this.props.isStopped()}
          onTouchTap={this.handleDialogOpen}
          icon={<List />}
        />)}
        {this.state.open ? exerciseDialog : null}
        {!this.props.standAlone && (
        <RaisedButton
          id="viewReport"
          style={style}
          disabled={!this.props.isStopped()}
          onTouchTap={this.handleReportDialogOpen}
          icon={<Assignment />}
          label={downloadLabel}
        />)}
        {reportDialog}

      </div>
        );
  }
}

export default PronounceMenu;



// WEBPACK FOOTER //
// ./src/components/PronounceMenu.js